<!-- ConfirmationModal.vue -->
<template>
    <div class="modal duration-100 fade fixed inset-0 bg-blacker bg-opacity-70 bg-blurry hidden" id="confirmationModal" tabindex="-1">
        <div class="flex items-center justify-center h-full">
            <div class="modal-dialog bg-dark rounded-lg inline-block shadow-wide shadow-lg max-w-md w-full md:w-1/2 xl:w-1/4">
                <div class="modal-content">
                    <div class="modal-header border-b border-grey border-opacity-25 px-6 py-4 flex justify-between items-center">
                        <h5 class="modal-title text-lg font-semibold" id="confirmationModalLabel">{{ title }}</h5>
                        <button type="button" class="text-grey-400 hover:text-white" data-bs-dismiss="modal" aria-label="Close">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body px-6 py-4 ">
                        <p class="mb-4" v-html="message"></p>
                    </div>
                    <div class="border-t border-grey border-opacity-25 mt-3 pt-2 flex justify-end space-x-4">
                        <div class="flex items-center text-grey mr-3">
                            <input class="mr-2 rounded cursor-pointer" type="checkbox" v-model="dontAskAgain" id="dontAskAgain">
                            <label class="text-grey-300 cursor-pointer" for="dontAskAgain">
                                Don't ask again
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer flex justify-end px-4 mb-4 mt-2">
                        <VButton data-bs-dismiss="modal" variant="darker" class="mr-3">CANCEL</VButton>
                        <VButton variant="red" @click="proceed">PROCEED</VButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as bootstrap from "bootstrap";
import VButton from "./VButton.vue";

export default {
    components: {
        VButton
    },
    data() {
        return {
            title: "",
            message: "",
            dontAskAgain: false,
            action: null,
            storageKey: "",
        };
    },
    methods: {
        show(title, message, action, storageKey) {
            this.title = title;
            this.message = message;
            this.action = action;
            this.dontAskAgain = false;
            this.storageKey = storageKey;
            const modal = new bootstrap.Modal(document.getElementById("confirmationModal"));
            modal.show();
        },
        proceed() {
            console.log("Proceed?")
            if (this.dontAskAgain) {
                localStorage.setItem(this.storageKey, "true");
            }
            if (this.action) {
                this.action();
            }
            const modal = bootstrap.Modal.getInstance(document.getElementById("confirmationModal"));
            modal.hide();
        },
    },
};
</script>

<style scoped>
p {
  white-space: pre-line;
}
</style>
